<template>
  <div class="agent">
    <!-- 页面头部 -->
    <section class="page-header">
      <div class="container">
        <h1>代理加盟</h1>
        <p>完善的代理系统和规范的代理制度</p>
        <div class="header-action">
          <a href="#contact" class="btn btn-primary">联系客服</a>
        </div>
      </div>
    </section>

    <!-- 代理优势 -->
    <section class="agent-advantages section">
      <div class="container">
        <h2 class="section-title">代理优势</h2>
        <div class="advantages-grid">
          <div class="advantage-card card">
            <div class="advantage-icon">💼</div>
            <h3>完善的代理系统</h3>
            <p>产品完善的代理系统和规范的代理制度，让你销售无后顾之忧</p>
          </div>
          <div class="advantage-card card">
            <div class="advantage-icon">🛠️</div>
            <h3>专业售后支持</h3>
            <p>当你无法为客户解决的疑难问题，专业售后可一对一远程处理</p>
          </div>
          <div class="advantage-card card">
            <div class="advantage-icon">💰</div>
            <h3>丰厚利润空间</h3>
            <p>绝对保障的利润空间让努力的你得到丰厚的收入</p>
          </div>
          <div class="advantage-card card">
            <div class="advantage-icon">📈</div>
            <h3>持续收益</h3>
            <p>客户续费带来持续收益，建立稳定的收入来源</p>
          </div>
          <div class="advantage-card card">
            <div class="advantage-icon">🎯</div>
            <h3>市场前景广阔</h3>
            <p>助手自动化需求不断增长，市场潜力巨大</p>
          </div>
          <div class="advantage-card card">
            <div class="advantage-icon">🤝</div>
            <h3>全程技术支持</h3>
            <p>从销售到售后，全程提供技术支持和培训</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 代理政策 -->
    <section class="agent-policy section">
      <div class="container">
        <h2 class="section-title">代理政策</h2>
        <div class="policy-content">
          <div class="policy-levels">
            <div class="level-card card">
              <div class="level-badge">初级代理</div>
              <div class="level-icon">🥉</div>
              <h3>入门级代理</h3>
              <div class="level-features">
                <div class="feature-item">
                  <span class="feature-icon">✓</span>
                  <span>基础代理权限</span>
                </div>
                <div class="feature-item">
                  <span class="feature-icon">✓</span>
                  <span>标准利润分成</span>
                </div>
                <div class="feature-item">
                  <span class="feature-icon">✓</span>
                  <span>技术支持</span>
                </div>
                <div class="feature-item">
                  <span class="feature-icon">✓</span>
                  <span>销售培训</span>
                </div>
              </div>
              <div class="level-commission">
                <span class="commission-label">佣金比例</span>
                <span class="commission-value">20-30%</span>
              </div>
            </div>

            <div class="level-card card featured">
              <div class="level-badge">高级代理</div>
              <div class="level-icon">🥈</div>
              <h3>专业级代理</h3>
              <div class="level-features">
                <div class="feature-item">
                  <span class="feature-icon">✓</span>
                  <span>高级代理权限</span>
                </div>
                <div class="feature-item">
                  <span class="feature-icon">✓</span>
                  <span>优质利润分成</span>
                </div>
                <div class="feature-item">
                  <span class="feature-icon">✓</span>
                  <span>优先技术支持</span>
                </div>
                <div class="feature-item">
                  <span class="feature-icon">✓</span>
                  <span>专业培训</span>
                </div>
                <div class="feature-item">
                  <span class="feature-icon">✓</span>
                  <span>市场推广支持</span>
                </div>
              </div>
              <div class="level-commission">
                <span class="commission-label">佣金比例</span>
                <span class="commission-value">30-40%</span>
              </div>
            </div>

            <div class="level-card card">
              <div class="level-badge">顶级代理</div>
              <div class="level-icon">🥇</div>
              <h3>钻石级代理</h3>
              <div class="level-features">
                <div class="feature-item">
                  <span class="feature-icon">✓</span>
                  <span>顶级代理权限</span>
                </div>
                <div class="feature-item">
                  <span class="feature-icon">✓</span>
                  <span>最高利润分成</span>
                </div>
                <div class="feature-item">
                  <span class="feature-icon">✓</span>
                  <span>专属技术支持</span>
                </div>
                <div class="feature-item">
                  <span class="feature-icon">✓</span>
                  <span>定制化培训</span>
                </div>
                <div class="feature-item">
                  <span class="feature-icon">✓</span>
                  <span>独家市场资源</span>
                </div>
                <div class="feature-item">
                  <span class="feature-icon">✓</span>
                  <span>品牌授权</span>
                </div>
              </div>
              <div class="level-commission">
                <span class="commission-label">佣金比例</span>
                <span class="commission-value">40-50%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 免费兑换活动 -->
    <section class="exchange-activity section">
      <div class="container">
        <h2 class="section-title">免费兑换活动</h2>
        <div class="activity-content">
          <div class="activity-card card">
            <div class="activity-icon">🎁</div>
            <h3>软件免费兑换</h3>
            <div class="activity-description">
              <p>只要您使用其他产品软件未过期，可凭相应日期证明，即可免费兑换掌柜软件相应时间。</p>
              <div class="example-box">
                <h4>兑换示例：</h4>
                <p>例如您在其他软件距到期还有25天，您可凭借相应证明，联系客服人员兑换对应掌柜软件25天免费使用</p>
              </div>
            </div>
            <div class="activity-steps">
              <div class="step">
                <span class="step-number">1</span>
                <span class="step-text">提供其他软件使用证明</span>
              </div>
              <div class="step">
                <span class="step-number">2</span>
                <span class="step-text">联系客服人员验证</span>
              </div>
              <div class="step">
                <span class="step-number">3</span>
                <span class="step-text">获得对应时长免费使用</span>
              </div>
            </div>
            <a href="#contact" class="btn btn-primary">立即兑换</a>
          </div>
        </div>
      </div>
    </section>

    <!-- 网盘对接业务 -->
    <section class="disk-service section">
      <div class="container">
        <h2 class="section-title">网盘对接业务</h2>
        <div class="service-content">
          <div class="service-card card">
            <div class="service-icon">💾</div>
            <h3>专业网盘对接</h3>
            <div class="service-description">
              <p>有需要在软件挂盘需求可直接联系官方接洽对接业务。</p>
              <div class="service-note">
                <h4>重要说明：</h4>
                <p>飞单入口对接仅为三方增值业务，网盘收益与我们无任何关联。</p>
              </div>
            </div>
            <div class="service-features">
              <div class="feature-item">
                <span class="feature-icon">🔗</span>
                <span>专业对接服务</span>
              </div>
              <div class="feature-item">
                <span class="feature-icon">⚡</span>
                <span>快速响应</span>
              </div>
              <div class="feature-item">
                <span class="feature-icon">🛡️</span>
                <span>安全可靠</span>
              </div>
              <div class="feature-item">
                <span class="feature-icon">📞</span>
                <span>专业咨询</span>
              </div>
            </div>
            <a href="#contact" class="btn btn-secondary">咨询对接</a>
          </div>
        </div>
      </div>
    </section>

    <!-- 加盟流程 -->
    <section class="join-process section">
      <div class="container">
        <h2 class="section-title">加盟流程</h2>
        <div class="process-steps">
          <div class="process-item">
            <div class="process-number">1</div>
            <div class="process-content">
              <h3>咨询了解</h3>
              <p>联系客服了解代理政策和要求</p>
            </div>
          </div>
          <div class="process-item">
            <div class="process-number">2</div>
            <div class="process-content">
              <h3>资质审核</h3>
              <p>提交相关资料进行代理资质审核</p>
            </div>
          </div>
          <div class="process-item">
            <div class="process-number">3</div>
            <div class="process-content">
              <h3>签署协议</h3>
              <p>签署代理合作协议，明确权责</p>
            </div>
          </div>
          <div class="process-item">
            <div class="process-number">4</div>
            <div class="process-content">
              <h3>培训支持</h3>
              <p>接受产品培训和销售技巧培训</p>
            </div>
          </div>
          <div class="process-item">
            <div class="process-number">5</div>
            <div class="process-content">
              <h3>开始销售</h3>
              <p>正式开始代理销售，获得收益</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section id="contact" class="contact section">
      <div class="container">
        <h2 class="section-title">联系我们</h2>
        <div class="contact-content">
          <div class="contact-info card">
            <h3>代理咨询</h3>
            <div class="contact-methods">
              <div class="contact-method">
                <div class="method-icon">💬</div>
                <div class="method-info">
                  <h4>在线客服</h4>
                  <p>实时在线，快速响应</p>
                </div>
              </div>
              <div class="contact-method">
                <div class="method-icon">📞</div>
                <div class="method-info">
                  <h4>电话咨询</h4>
                  <p>专业客服为您详细解答</p>
                </div>
              </div>
              <div class="contact-method">
                <div class="method-icon">📧</div>
                <div class="method-info">
                  <h4>邮件咨询</h4>
                  <p>发送详细需求，获得专业回复</p>
                </div>
              </div>
            </div>
            <div class="contact-buttons">
              <!-- <a href="https://t.me/ZG000001" class="btn">Telegram</a> -->
              <!-- <a href="https://t.me/zg999999" class="btn">Telegram</a> -->
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Agent',
  mounted() {
    this.animateOnScroll()
  },
  methods: {
    animateOnScroll() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in')
          }
        })
      })

      const elements = document.querySelectorAll('.card, .process-item, .contact-method')
      elements.forEach(el => observer.observe(el))
    }
  }
}
</script>

<style scoped>
.page-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 80px 0 60px;
  text-align: center;
}

.page-header h1 {
  font-size: 42px;
  font-weight: bold;
  margin-bottom: 15px;
}

.page-header p {
  font-size: 18px;
  opacity: 0.9;
  margin-bottom: 30px;
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.advantage-card {
  text-align: center;
  padding: 40px 30px;
  transition: all 0.3s ease;
}

.advantage-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
}

.advantage-icon {
  font-size: 48px;
  margin-bottom: 20px;
}

.advantage-card h3 {
  font-size: 20px;
  color: #333;
  margin-bottom: 15px;
}

.advantage-card p {
  color: #666;
  line-height: 1.6;
}

.agent-policy {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.policy-levels {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 30px;
}

.level-card {
  text-align: center;
  padding: 40px 30px;
  position: relative;
  transition: all 0.3s ease;
}

.level-card.featured {
  transform: scale(1.05);
  border: 3px solid #667eea;
}

.level-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
}

.level-card.featured:hover {
  transform: scale(1.05) translateY(-10px);
}

.level-badge {
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(45deg, #667eea, #764ba2);
  color: white;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: bold;
}

.level-icon {
  font-size: 48px;
  margin: 20px 0;
}

.level-card h3 {
  font-size: 22px;
  color: #333;
  margin-bottom: 25px;
}

.level-features {
  margin-bottom: 30px;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  text-align: left;
}

.feature-icon {
  color: #28a745;
  font-weight: bold;
  margin-right: 10px;
  width: 20px;
}

.level-commission {
  background: linear-gradient(45deg, #28a745, #20c997);
  color: white;
  padding: 15px;
  border-radius: 10px;
  margin-top: 20px;
}

.commission-label {
  display: block;
  font-size: 14px;
  opacity: 0.9;
}

.commission-value {
  display: block;
  font-size: 24px;
  font-weight: bold;
  margin-top: 5px;
}

.exchange-activity {
  background: white;
}

.activity-card {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  padding: 50px 40px;
}

.activity-icon {
  font-size: 64px;
  margin-bottom: 30px;
}

.activity-card h3 {
  font-size: 28px;
  color: #333;
  margin-bottom: 25px;
}

.activity-description p {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 25px;
}

.example-box {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 10px;
  border-left: 4px solid #667eea;
  margin: 25px 0;
  text-align: left;
}

.example-box h4 {
  color: #333;
  margin-bottom: 10px;
}

.activity-steps {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin: 40px 0;
  flex-wrap: wrap;
}

.step {
  display: flex;
  align-items: center;
  gap: 10px;
}

.step-number {
  width: 30px;
  height: 30px;
  background: linear-gradient(45deg, #667eea, #764ba2);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.step-text {
  color: #666;
  font-size: 14px;
}

.disk-service {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.service-card {
  max-width: 700px;
  margin: 0 auto;
  text-align: center;
  padding: 50px 40px;
}

.service-icon {
  font-size: 64px;
  margin-bottom: 30px;
}

.service-card h3 {
  font-size: 28px;
  color: #333;
  margin-bottom: 25px;
}

.service-description p {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 20px;
}

.service-note {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  padding: 20px;
  border-radius: 10px;
  margin: 25px 0;
  text-align: left;
}

.service-note h4 {
  color: #856404;
  margin-bottom: 10px;
}

.service-note p {
  color: #856404;
  margin: 0;
}

.service-features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 20px;
  margin: 30px 0;
}

.join-process {
  background: white;
}

.process-steps {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 1000px;
  margin: 0 auto;
  flex-wrap: wrap;
  gap: 20px;
}

.process-item {
  flex: 1;
  min-width: 180px;
  text-align: center;
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.6s ease;
}

.process-item.animate-in {
  opacity: 1;
  transform: translateY(0);
}

.process-number {
  width: 60px;
  height: 60px;
  background: linear-gradient(45deg, #667eea, #764ba2);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: bold;
  margin: 0 auto 20px;
}

.process-content h3 {
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
}

.process-content p {
  color: #666;
  font-size: 14px;
  line-height: 1.5;
}

.contact {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: white;
}

.contact .section-title {
  color: white;
}

.contact-info {
  max-width: 600px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 50px 40px;
  text-align: center;
}

.contact-info h3 {
  font-size: 28px;
  color: #3498db;
  margin-bottom: 30px;
}

.contact-methods {
  margin-bottom: 40px;
}

.contact-method {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  opacity: 0;
  transform: translateX(-30px);
  transition: all 0.6s ease;
}

.contact-method.animate-in {
  opacity: 1;
  transform: translateX(0);
}

.method-icon {
  font-size: 32px;
  margin-right: 20px;
  width: 50px;
  text-align: center;
}

.method-info {
  text-align: left;
}

.method-info h4 {
  font-size: 18px;
  color: white;
  margin-bottom: 5px;
}

.method-info p {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
}

.contact-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .page-header {
    padding: 60px 0 40px;
  }
  
  .page-header h1 {
    font-size: 32px;
  }
  
  .advantages-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .policy-levels {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .level-card.featured {
    transform: none;
  }
  
  .activity-steps {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  
  .service-features {
    grid-template-columns: 1fr;
  }
  
  .process-steps {
    flex-direction: column;
    align-items: center;
  }
  
  .contact-method {
    flex-direction: column;
    text-align: center;
  }
  
  .method-icon {
    margin-right: 0;
    margin-bottom: 10px;
  }
  
  .method-info {
    text-align: center;
  }
  
  .contact-buttons {
    flex-direction: column;
  }
}
</style>
